import React, { useState } from 'react';
import '../styles/Membership.css';
import heroBg from '../assets/images/Investment-Guide-BG.jpg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import {
  faComments,
  faLightbulb,
  faHouse,
  faFileContract,
  faHandHoldingUsd,
  faChartBar,
  faUserTie,
  faGem
} from '@fortawesome/free-solid-svg-icons';
import moneyBackLogo from '../assets/images/Money-Back-Guarantee.png';
import MembershipFormModal from '../components/MembershipFormModal';

const Membership = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const handleScrollToPrivileges = () => {
    const privilegesSection = document.querySelector('.membership-privileges-section');
    if (privilegesSection) {
      privilegesSection.scrollIntoView({ behavior: 'smooth' });
    }
  };
  const handleFormSubmit = (formData) => {
    // TODO: Send to backend API
    setModalOpen(false);
    alert('Membership form submitted!');
  };

  return (
    <div className="membership-page">
      {/* Hero Section*/}
      <div
        className="membership-hero"
        style={{ backgroundImage: `url(${heroBg})` }}
      >
        <div className="membership-hero-overlay"></div>
        <div className="membership-hero-content">
          {/* <h1 className="membership-hero-title">Membership</h1> */}
          <h2 className="membership-hero-title">Exclusive Dubai Property Investment Opportunities</h2>
          <h3 className="membership-hero-tagline">Unlock Access to Premium Deals & Insider Information</h3>
          <button
            className="down-arrow-btn"
            aria-label="Scroll to Member Privileges"
            onClick={handleScrollToPrivileges}
            style={{ background: 'none', border: 'none', marginTop: '32px', cursor: 'pointer' }}
          >
            <FontAwesomeIcon icon={faChevronDown} size="2x" style={{ color: '#fff' }} />
          </button>
        </div>
      </div>
      <MembershipFormModal open={modalOpen} onClose={() => setModalOpen(false)} onSubmit={handleFormSubmit} />
      <div className="membership-container">
      <section className="membership-container">
        {/* <h1>Exclusive Dubai Property Investment Opportunities</h1> */}
        <h2>Unlock Access to Premium Deals & Insider Information</h2>
        <p>
          Are you ready to take advantage of exclusive property investment opportunities in one of the world's fastest-growing real estate markets? At ABBASS Global Properties, our membership gives you privileged access to premium deals, expert insights, and tailored investment strategies to maximise your returns.<br /><br />
          Join an elite group of investors and be the first to discover high-potential properties in Dubai's luxury and emerging markets. Let us guide you through your investment journey with confidence and expertise.
        </p>
      </section>

      {/* Member Privileges Section */}
      <section className="membership-privileges-section">
        <h2>Member Privileges</h2>
        <div className="privileges-intro">As a member, you'll enjoy these exclusive benefits:</div>
        <div className="privileges-grid">
          <div className="privilege-item">
              <div className="privilege-icon"><FontAwesomeIcon icon={faComments} /></div>
            <div className="privilege-title">Property Consultation</div>
            <div className="privilege-desc">We sit down and discuss your property needs and ensure expectations are aligned and reasonable</div>
          </div>
          <div className="privilege-item">
              <div className="privilege-icon"><FontAwesomeIcon icon={faLightbulb} /></div>
            <div className="privilege-title">Strategy Session</div>
            <div className="privilege-desc">We do as many strategy sessions as it takes to set up your perfect property</div>
          </div>
          <div className="privilege-item">
              <div className="privilege-icon"><FontAwesomeIcon icon={faHouse} /></div>
            <div className="privilege-title">Property Presentation</div>
            <div className="privilege-desc">Presentation of exclusive properties including all supporting reports and other artifacts to help you with your decision making</div>
          </div>
          <div className="privilege-item">
              <div className="privilege-icon"><FontAwesomeIcon icon={faFileContract} /></div>
            <div className="privilege-title">Access To Conveyancing</div>
            <div className="privilege-desc">Access to our conveyancing partners who will help you with your property contractual needs</div>
          </div>
          <div className="privilege-item">
              <div className="privilege-icon"><FontAwesomeIcon icon={faHandHoldingUsd} /></div>
            <div className="privilege-title">Access To Mortgage & Finance</div>
            <div className="privilege-desc">Access to our mortgage & finance partners who will help you with your lending requirements</div>
          </div>
          <div className="privilege-item">
              <div className="privilege-icon"><FontAwesomeIcon icon={faChartBar} /></div>
            <div className="privilege-title">Research Reports</div>
            <div className="privilege-desc">Access to our in depth research reports and property reports</div>
          </div>
          <div className="privilege-item">
              <div className="privilege-icon"><FontAwesomeIcon icon={faUserTie} /></div>
            <div className="privilege-title">Personal Property Strategist</div>
            <div className="privilege-desc">24/7 access to your personal property strategist</div>
          </div>
          <div className="privilege-item">
              <div className="privilege-icon"><FontAwesomeIcon icon={faGem} /></div>
            <div className="privilege-title">Exclusive Deals</div>
            <div className="privilege-desc">Access to exclusive property deals not available to the public</div>
          </div>
        </div>
      </section>

      {/* Offer Section */}
      <section className="membership-offer-section">
        <div className="offer-main">Limited Time: <span className="offer-highlight">Become a Member for Only 797 AED</span> (Regularly 2,977 AED)</div>
        <div className="offer-sub">Secure your spot and start investing smarter today!</div>
        <button className="membership-cta-btn" onClick={() => setModalOpen(true)}>Become a Member</button>
      </section>

      {/* Guarantee Section */}
      <section className="membership-guarantee-section">
          <div className="membership-guarantee-content">
            <div className="guarantee-text">
        <h2>Our 100% Money Back Guarantee:</h2>
              <p>
                Not confident or satisfied with anything at all? Send us an email to <span className="highlight-email">info@abbass.group</span> within 90 days of purchasing a membership and we will refund you the amount in full. <span className="highlight-text">No questions asked!</span>
              </p>
            </div>
            <div className="guarantee-logo">
              <img src={moneyBackLogo} alt="100% Money Back Guarantee" />
            </div>
          </div>
      </section>

      {/* Agreement Section */}
      <section className="membership-agreement-section">
        <h2>Membership Agreement</h2>
        <div className="agreement-note">We believe in transparency. Please review our Terms & Conditions and Privacy Policy before joining.</div>
        <div className="membership-agreement-btns">
          <a href="/terms-and-conditions" className="membership-link-btn">View Terms & Conditions</a>
          <a href="/privacy-policy" className="membership-link-btn">View Privacy Policy</a>
        </div>
      </section>

      {/* Accept Section */}
      <section className="membership-accept-section">
        <p className="accept-text">Ready to unlock your exclusive benefits? Click ‘Accept’ to join our community of successful investors.</p>
        <button className="accept-btn" onClick={() => setModalOpen(true)}>Accept →</button>
      </section>
      </div>
    </div>
  );
};

export default Membership; 